import { MyEbookTab } from './MyEbookTab'
import { withMyEbookTab } from './withMyEbookTab'

const Connected = withMyEbookTab(MyEbookTab)

export { Connected as MyEbookTab }
